import throttle from 'lodash/throttle';

class RevealOnScroll {
	constructor(els, thresholdPercent) {
		this.itemsToReveal = Array.from(els || []);
		this.browserHeight = window.innerHeight;
		this.thresholdPercent = thresholdPercent || 75;

		if (!this.itemsToReveal.length) {
			return;
		}

		this.scrollThrottle = throttle(() => this.calcCaller(), 200);

		this.hideInitially();
		this.events();
		this.calcCaller();
	}

	events() {
		window.addEventListener('scroll', this.scrollThrottle);

		window.addEventListener('resize', () => {
			this.browserHeight = window.innerHeight;
		})
	}

	calcCaller() {
		this.itemsToReveal.forEach((el) => {
			if (!el.isRevealed) {
				this.calculateIfScrolledTo(el);
			}
		});
	}

	calculateIfScrolledTo(el) {
		const scrollPercent = (el.getBoundingClientRect().top / this.browserHeight) * 100

		if (scrollPercent < this.thresholdPercent) {
			el.classList.add('reveal-item--is-visible');
			el.isRevealed = true;

			if (el.isLastItem) {
				window.removeEventListener('scroll', this.scrollThrottle);
			}
		}
	}

	hideInitially() {
		this.itemsToReveal.forEach((el) => {
			el.classList.add('reveal-item');
			el.isRevealed = false;
		});

		const lastItem = this.itemsToReveal[this.itemsToReveal.length - 1]

		if (lastItem) {
			lastItem.isLastItem = true;
		}
	}
}

export default RevealOnScroll;
